// src/utils/countries.ts

export interface CountryOption {
    code: string;
    iso: string;
    name: string;
}

export const ddiOptions: CountryOption[] = [
    // --- LUSÓFONOS (Prioridade Whiz) ---
    { code: '55', iso: 'br', name: 'Brasil' },
    { code: '351', iso: 'pt', name: 'Portugal' },
    { code: '244', iso: 'ao', name: 'Angola' },
    { code: '258', iso: 'mz', name: 'Moçambique' },
    { code: '238', iso: 'cv', name: 'Cabo Verde' },
    { code: '245', iso: 'gw', name: 'Guiné-Bissau' },
    { code: '239', iso: 'st', name: 'São Tomé e Príncipe' },
    { code: '670', iso: 'tl', name: 'Timor-Leste' },
    { code: '853', iso: 'mo', name: 'Macau' },

    // --- AMÉRICA ---
    { code: '1', iso: 'us', name: 'Estados Unidos' },
    { code: '1', iso: 'ca', name: 'Canadá' },
    { code: '54', iso: 'ar', name: 'Argentina' },
    { code: '591', iso: 'bo', name: 'Bolívia' },
    { code: '56', iso: 'cl', name: 'Chile' },
    { code: '57', iso: 'co', name: 'Colômbia' },
    { code: '506', iso: 'cr', name: 'Costa Rica' },
    { code: '53', iso: 'cu', name: 'Cuba' },
    { code: '593', iso: 'ec', name: 'Equador' },
    { code: '503', iso: 'sv', name: 'El Salvador' },
    { code: '502', iso: 'gt', name: 'Guatemala' },
    { code: '509', iso: 'ht', name: 'Haiti' },
    { code: '504', iso: 'hn', name: 'Honduras' },
    { code: '52', iso: 'mx', name: 'México' },
    { code: '505', iso: 'ni', name: 'Nicarágua' },
    { code: '507', iso: 'pa', name: 'Panamá' },
    { code: '595', iso: 'py', name: 'Paraguai' },
    { code: '51', iso: 'pe', name: 'Peru' },
    { code: '598', iso: 'uy', name: 'Uruguai' },
    { code: '58', iso: 've', name: 'Venezuela' },
    { code: '1242', iso: 'bs', name: 'Bahamas' },
    { code: '1246', iso: 'bb', name: 'Barbados' },
    { code: '501', iso: 'bz', name: 'Belize' },
    { code: '1767', iso: 'dm', name: 'Dominica' },
    { code: '1809', iso: 'do', name: 'República Dominicana' },
    { code: '1473', iso: 'gd', name: 'Granada' },
    { code: '592', iso: 'gy', name: 'Guiana' },
    { code: '1876', iso: 'jm', name: 'Jamaica' },
    { code: '597', iso: 'sur', name: 'Suriname' },
    { code: '1868', iso: 'tt', name: 'Trinidad e Tobago' },

    // --- ÁFRICA ---
    { code: '27', iso: 'za', name: 'África do Sul' },
    { code: '213', iso: 'dz', name: 'Argélia' },
    { code: '229', iso: 'bj', name: 'Benim' },
    { code: '267', iso: 'bw', name: 'Botsuana' },
    { code: '226', iso: 'bf', name: 'Burkina Faso' },
    { code: '257', iso: 'bi', name: 'Burundi' },
    { code: '237', iso: 'cm', name: 'Camarões' },
    { code: '236', iso: 'cf', name: 'República Centro-Africana' },
    { code: '235', iso: 'td', name: 'Chade' },
    { code: '269', iso: 'km', name: 'Comores' },
    { code: '242', iso: 'cg', name: 'República do Congo' },
    { code: '243', iso: 'cd', name: 'República Democrática do Congo' },
    { code: '225', iso: 'ci', name: 'Costa do Marfim' },
    { code: '253', iso: 'dj', name: 'Djibuti' },
    { code: '20', iso: 'eg', name: 'Egito' },
    { code: '291', iso: 'er', name: 'Eritreia' },
    { code: '251', iso: 'et', name: 'Etiópia' },
    { code: '241', iso: 'ga', name: 'Gabão' },
    { code: '220', iso: 'gm', name: 'Gâmbia' },
    { code: '233', iso: 'gh', name: 'Gana' },
    { code: '224', iso: 'gn', name: 'Guiné' },
    { code: '240', iso: 'gq', name: 'Guiné Equatorial' },
    { code: '266', iso: 'ls', name: 'Lesoto' },
    { code: '231', iso: 'lr', name: 'Libéria' },
    { code: '218', iso: 'ly', name: 'Líbia' },
    { code: '261', iso: 'mg', name: 'Madagascar' },
    { code: '265', iso: 'mw', name: 'Maláui' },
    { code: '223', iso: 'ml', name: 'Mali' },
    { code: '212', iso: 'ma', name: 'Marrocos' },
    { code: '222', iso: 'mr', name: 'Mauritânia' },
    { code: '230', iso: 'mu', name: 'Maurício' },
    { code: '264', iso: 'na', name: 'Namíbia' },
    { code: '227', iso: 'ne', name: 'Níger' },
    { code: '234', iso: 'ng', name: 'Nigéria' },
    { code: '254', iso: 'ke', name: 'Quênia' },
    { code: '250', iso: 'rw', name: 'Ruanda' },
    { code: '221', iso: 'sn', name: 'Senegal' },
    { code: '248', iso: 'sc', name: 'Seychelles' },
    { code: '232', iso: 'sl', name: 'Serra Leoa' },
    { code: '252', iso: 'so', name: 'Somália' },
    { code: '268', iso: 'sz', name: 'Essuatíni' },
    { code: '249', iso: 'sd', name: 'Sudão' },
    { code: '211', iso: 'ss', name: 'Sudão do Sul' },
    { code: '255', iso: 'tz', name: 'Tanzânia' },
    { code: '228', iso: 'tg', name: 'Togo' },
    { code: '216', iso: 'tn', name: 'Tunísia' },
    { code: '256', iso: 'ug', name: 'Uganda' },
    { code: '260', iso: 'zm', name: 'Zâmbia' },
    { code: '263', iso: 'zw', name: 'Zimbábue' },

    // --- ÁSIA ---
    { code: '93', iso: 'af', name: 'Afeganistão' },
    { code: '374', iso: 'am', name: 'Armênia' },
    { code: '994', iso: 'az', name: 'Azerbaijão' },
    { code: '973', iso: 'bh', name: 'Bahrein' },
    { code: '880', iso: 'bd', name: 'Bangladesh' },
    { code: '975', iso: 'bt', name: 'Butão' },
    { code: '673', iso: 'bn', name: 'Brunei' },
    { code: '855', iso: 'kh', name: 'Camboja' },
    { code: '86', iso: 'cn', name: 'China' },
    { code: '357', iso: 'cy', name: 'Chipre' },
    { code: '850', iso: 'kp', name: 'Coreia do Norte' },
    { code: '82', iso: 'kr', name: 'Coreia do Sul' },
    { code: '971', iso: 'ae', name: 'Emirados Árabes Unidos' },
    { code: '995', iso: 'ge', name: 'Geórgia' },
    { code: '91', iso: 'in', name: 'Índia' },
    { code: '62', iso: 'id', name: 'Indonésia' },
    { code: '98', iso: 'ir', name: 'Irã' },
    { code: '964', iso: 'iq', name: 'Iraque' },
    { code: '972', iso: 'il', name: 'Israel' },
    { code: '81', iso: 'jp', name: 'Japão' },
    { code: '962', iso: 'jo', name: 'Jordânia' },
    { code: '7', iso: 'kz', name: 'Cazaquistão' },
    { code: '965', iso: 'kw', name: 'Kuwait' },
    { code: '961', iso: 'lb', name: 'Líbano' },
    { code: '856', iso: 'la', name: 'Laos' },
    { code: '60', iso: 'my', name: 'Malásia' },
    { code: '960', iso: 'mv', name: 'Maldivas' },
    { code: '976', iso: 'mn', name: 'Mongólia' },
    { code: '95', iso: 'mm', name: 'Mianmar' },
    { code: '977', iso: 'np', name: 'Nepal' },
    { code: '968', iso: 'om', name: 'Omã' },
    { code: '92', iso: 'pk', name: 'Paquistão' },
    { code: '63', iso: 'ph', name: 'Filipinas' },
    { code: '974', iso: 'qa', name: 'Catar' },
    { code: '966', iso: 'sa', name: 'Arábia Saudita' },
    { code: '65', iso: 'sg', name: 'Singapura' },
    { code: '94', iso: 'lk', name: 'Sri Lanka' },
    { code: '963', iso: 'sy', name: 'Síria' },
    { code: '886', iso: 'tw', name: 'Taiwan' },
    { code: '992', iso: 'tj', name: 'Tajiquistão' },
    { code: '66', iso: 'th', name: 'Tailândia' },
    { code: '993', iso: 'tm', name: 'Turcomenistão' },
    { code: '90', iso: 'tr', name: 'Turquia' },
    { code: '998', iso: 'uz', name: 'Uzbequistão' },
    { code: '84', iso: 'vn', name: 'Vietnã' },
    { code: '967', iso: 'ye', name: 'Iêmen' },

    // --- EUROPA ---
    { code: '355', iso: 'al', name: 'Albânia' },
    { code: '49', iso: 'de', name: 'Alemanha' },
    { code: '376', iso: 'ad', name: 'Andorra' },
    { code: '43', iso: 'at', name: 'Áustria' },
    { code: '32', iso: 'be', name: 'Bélgica' },
    { code: '387', iso: 'ba', name: 'Bósnia e Herzegovina' },
    { code: '359', iso: 'bg', name: 'Bulgária' },
    { code: '385', iso: 'hr', name: 'Croácia' },
    { code: '45', iso: 'dk', name: 'Dinamarca' },
    { code: '421', iso: 'sk', name: 'Eslováquia' },
    { code: '386', iso: 'si', name: 'Eslovênia' },
    { code: '34', iso: 'es', name: 'Espanha' },
    { code: '372', iso: 'ee', name: 'Estônia' },
    { code: '358', iso: 'fi', name: 'Finlândia' },
    { code: '33', iso: 'fr', name: 'França' },
    { code: '30', iso: 'gr', name: 'Grécia' },
    { code: '36', iso: 'hu', name: 'Hungria' },
    { code: '353', iso: 'ie', name: 'Irlanda' },
    { code: '354', iso: 'is', name: 'Islândia' },
    { code: '39', iso: 'it', name: 'Itália' },
    { code: '383', iso: 'xk', name: 'Kosovo' },
    { code: '371', iso: 'lv', name: 'Letônia' },
    { code: '370', iso: 'lt', name: 'Lituânia' },
    { code: '352', iso: 'lu', name: 'Luxemburgo' },
    { code: '356', iso: 'mt', name: 'Malta' },
    { code: '373', iso: 'md', name: 'Moldávia' },
    { code: '377', iso: 'mc', name: 'Mônaco' },
    { code: '382', iso: 'me', name: 'Montenegro' },
    { code: '47', iso: 'no', name: 'Noruega' },
    { code: '31', iso: 'nl', name: 'Países Baixos' },
    { code: '48', iso: 'pl', name: 'Polônia' },
    { code: '44', iso: 'gb', name: 'Reino Unido' },
    { code: '420', iso: 'cz', name: 'República Tcheca' },
    { code: '40', iso: 'ro', name: 'Romênia' },
    { code: '7', iso: 'ru', name: 'Rússia' },
    { code: '378', iso: 'sm', name: 'San Marino' },
    { code: '46', iso: 'se', name: 'Suécia' },
    { code: '41', iso: 'ch', name: 'Suíça' },
    { code: '380', iso: 'ua', name: 'Ucrânia' },

    // --- OCEANIA ---
    { code: '61', iso: 'au', name: 'Austrália' },
    { code: '64', iso: 'nz', name: 'Nova Zelândia' },
    { code: '679', iso: 'fj', name: 'Fiji' },
    { code: '686', iso: 'ki', name: 'Quiribati' },
    { code: '692', iso: 'mh', name: 'Ilhas Marshall' },
    { code: '691', iso: 'fm', name: 'Micronésia' },
    { code: '674', iso: 'nr', name: 'Nauru' },
    { code: '687', iso: 'nc', name: 'Nova Caledônia' },
    { code: '675', iso: 'pg', name: 'Papua-Nova Guiné' },
    { code: '680', iso: 'pw', name: 'Palau' },
    { code: '677', iso: 'sb', name: 'Ilhas Salomão' },
    { code: '676', iso: 'to', name: 'Tonga' },
    { code: '688', iso: 'tv', name: 'Tuvalu' },
    { code: '678', iso: 'vu', name: 'Vanuatu' },
    { code: '681', iso: 'wf', name: 'Wallis e Futuna' },
    { code: '1684', iso: 'as', name: 'Samoa Americana' },
    { code: '682', iso: 'ck', name: 'Ilhas Cook' },
    { code: '689', iso: 'pf', name: 'Polinésia Francesa' },
    { code: '1671', iso: 'gu', name: 'Guam' }
];
/**
 * Países cujo DDI abre `digitos`, pelo DDI mais longo que casa (+1684 antes de +1).
 * DDI é livre de prefixo, então só há mais de um país quando o código é compartilhado
 * (+1 EUA/Canadá, +7 Rússia/Cazaquistão). `null` quando nenhum DDI da lista casa.
 */
export function paisesDoDdi(digitos: string, ignorar: string[] = []): { code: string, paises: CountryOption[] } | null {
    const code = ddiOptions
        .map(d => d.code)
        .filter(c => !ignorar.includes(c) && digitos.startsWith(c))
        .sort((a, b) => b.length - a.length)[0];
    return code ? { code, paises: ddiOptions.filter(d => d.code === code) } : null;
}
